export default {"src":"/_next/static/media/elevator.a1aa691d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};